module.exports = __webpack_public_path__ + "img/40.afa33e1a.jpg";